module.exports = __webpack_public_path__ + "static/gradient@2x-44d27394deeca630bd45bf0ea219bc33.jpg";